import { useSnapshot } from 'hooks/use-safe-snapshot';
import { state } from 'state/current-teams';

const useCurrentTeams = () => {
    const { teams } = useSnapshot(state);

    return teams;
};

export { useCurrentTeams };
